// Object Graph - Side Panel
export const OBJECT_GRAPH_SIDE_PANEL_MIN_WIDTH = 250;
export const OBJECT_GRAPH_SIDE_PANEL_MAX_WIDTH = 1000;
